import type { PostHog } from "posthog-js";

type FeatureFlagEvaluationClient = Pick<PostHog, "setPersonPropertiesForFlags">;

export const setFeatureFlagEvaluationProperties = (
  postHog: FeatureFlagEvaluationClient
): void =>
  postHog.setPersonPropertiesForFlags({
    environment: import.meta.env.MODE,
    host: window.location.host,
    $current_url: window.location.href,
  });
